import React from 'react';
import { Footer } from '@wfp/ui';

import { useEWUser } from '../../hooks/home';

const version = import.meta.env.VITE_VERSION;

export function PageFooter() {
	const feVersion = (version || '').split('-')[0];
	const beVersion = (useEWUser()?.version || '').split('-')[0];

	return (
		<Footer
			metaContent={`WFP OIMS ${beVersion} / EW ${feVersion} – powered by EME Division with full support of concerned divisions which are responsible for the accuracy of the content.`}>
		</Footer>
	);
}